import axios from 'axios';
import { merge, mergeWith, isArray } from 'lodash';

export default class AutomationLookup {
  constructor({ baseURL }) {
    this.baseURL = baseURL;
  }

  async login(accountId, username, password) {
    const result = await axios.post(`${this.baseURL}/login`, {
      accountId,
      username,
      password,
    });
    return result.data;
  }

  async logout() {
    const result = await axios.get(`${this.baseURL}/logout`);
    return result.data;
  }

  async createAutomation(bot) {
    // NOTE: Why is this checking for the presence of bot before using brandId?
    const result = await axios.post(`${this.baseURL}/brand/${bot && bot.brandId}/automation`, bot);
    return result.data;
  }

  async getAutomations(brandId) {
    const result = await axios.get(`${this.baseURL}/brand/${brandId}/automation`);
    return result.data;
  }

  async deleteAutomation(brandId, id) {
    await axios.delete(`${this.baseURL}/brand/${brandId}/automation/${id}`);
  }

  async createConfig(brandId, config) {
    const result = await axios.post(`${this.baseURL}/brand/${brandId}/config`, config);
    return result.data;
  }

  async getConfig(brandId) {
    const result = await axios.get(`${this.baseURL}/brand/${brandId}/config`);
    return result.data;
  }

  async updateConfig(brandId, config) {
    const previousConfig = await this.getConfig(brandId);
    const newConfig = merge(previousConfig, config);
    const res = await this.createConfig(brandId, newConfig);
    return {
      ...res,
      data: newConfig,
    };
  }

  async createKBConfig(brandId, config) {
    const result = await axios.post(`${this.baseURL}/brand/${brandId}/knowledgebaseconfig`, config);
    return result.data;
  }

  async getKBConfig(brandId) {
    const result = await axios.get(`${this.baseURL}/brand/${brandId}/knowledgebaseconfig`);
    return result.data;
  }

  async getKBList(brandId) {
    const result = await axios.get(`${this.baseURL}/brand/${brandId}/knowledgebase`);
    return result.data;
  }

  async getAgents(brandId) {
    const result = await axios.get(`${this.baseURL}/v1/account/${brandId}/agents`);
    return result.data;
  }

  async getSkills(brandId) {
    const result = await axios.get(`${this.baseURL}/v1/account/${brandId}/skills`);
    return result.data;
  }

  // Version 2 API

  async createConfigV2(brandId, config) {
    const result = await axios.post(`${this.baseURL}/v2/account/${brandId}/config`, config);
    return result.data;
  }

  async getConfigV2(brandId) {
    const result = await axios.get(`${this.baseURL}/v2/account/${brandId}/config`);
    return result.data;
  }

  async updateConfigV2(brandId, config) {
    const previousConfig = await this.getConfigV2(brandId) || {};
    const newConfig = mergeWith(previousConfig, config, (objValue, srcValue) => (isArray(objValue)
      ? objValue.concat(srcValue)
      : undefined));
    const res = await this.createConfigV2(brandId, newConfig);
    return {
      ...res,
      data: newConfig,
    };
  }

  async getAutomationsV2(brandId) {
    const result = await axios.get(`${this.baseURL}/v2/account/${brandId}/bot`);
    return result.data;
  }

  async updateAutomationV2(accountId, bot) {
    const result = await axios.put(`${this.baseURL}/v2/account/${accountId}/bot/${bot.botId}`, bot);
    return result.data;
  }

  async getKBListV2(brandId) {
    const result = await axios.get(`${this.baseURL}/v2/account/${brandId}/knowledgebase`);
    return result.data;
  }

  async updateKBV2(accountId, kb) {
    const result = await axios.put(`${this.baseURL}/v2/account/${accountId}/knowledgebase/${kb.knowledgeBaseId}`, kb);
    return result.data;
  }

  async deleteAutomationV2(brandId, id) {
    await axios.delete(`${this.baseURL}/v2/account/${brandId}/bot/${id}`);
  }

  async updateAutomationCredsV2(brandId, automations) {
    await axios.post(`${this.baseURL}/v2/account/${brandId}/le-user-credentials`, automations);
  }
}
